import React from 'react';
import {translateService, Translate} from "../../services/TranslateService";
import {cx} from "./util";
import styles from "./main.module.scss";
import {paymentMethod} from "./PaymentInfo";

interface AdditionalPaymentInfoContentProps {
    setModalClose: (open: boolean) => void;
}

export const AdditionalPaymentInfoContent: React.FC<AdditionalPaymentInfoContentProps> = ({ setModalClose }) => {
    // saving card info modal
    return (
        <div style={{textAlign: "center", justifyContent: "center"}}>
            <h1> {translateService.translate('vehicleSearch1.yourPaymentCardInfoHeading')} </h1>
            <br/>
            <h2> {translateService.translate('vehicleSearch1.processingYourCardDetails')} </h2>
            <div> {translateService.translate('vehicleSearch1.processingCardDetails')} </div>
            <br/>
            <h2> {translateService.translate('vehicleSearch1.savingYourCardInfo')} </h2>
            <div> {translateService.translate('vehicleSearch1.savingCardAddInfo')} </div>
            <br/>
            <h2> {translateService.translate('vehicleSearch1.savingYourCardUsage')} </h2>
            <div> {translateService.translate('vehicleSearch1.savingCardAddUsage')} </div>
            <button onClick={() => setModalClose(false)}
                    className='btn btn-primary btn-outline-primary btn-cta mt-2 w-50 m-auto'>
                {translateService.translate('vehicleSearch.close')}
            </button>
        </div>
    )

}

interface SavedCardPaySelectProps {
    rootUrl: string | undefined;
    userCardType: string;
    userLastFourDigits: string;
}

export const SavedCardPaySelectContent: React.FC<SavedCardPaySelectProps> =
    ({ rootUrl, userCardType, userLastFourDigits  }) => {


    return (
        <div className={cx(styles.r24FullWidth, styles.r24AlingCenter)}>
            <div className='p-2'>
                <img
                    className={'bankLogo'}
                    width="75"
                    height="30"
                    src={rootUrl+'/assets/logos/banks/' + userCardType?.toLowerCase() + '.svg'}
                    alt={""} loading="lazy"/>
                <span style={{fontWeight: 600}}> xxxx xxxx xxxx {userLastFourDigits} </span>
            </div>
        </div>
    )
}

interface CardIconsProps {
    rootUrl: string | undefined;
}

export const CardIconsDisplay: React.FC<CardIconsProps> =
    ({ rootUrl  }) => {


        return (
            <div className={cx(styles.r24FullWidth, styles.r24AlingCenter)}>
                <div className='p-2 mb-1'>
                    <img className={'bankLogo'} width="75" height="30"
                         src={rootUrl+'/assets/logos/banks/mastercard.svg'}
                         alt={""} loading="lazy"/>
                    <img className={'bankLogo'} width="75" height="30"
                         src={rootUrl+'/assets/logos/banks/visa.svg'}
                         alt={""} loading="lazy"/>
                </div>
            </div>
        )


}

interface AddCardInfoProps {
    hasSavedCard: boolean;
    saveNewCard: boolean;
    setAdditionalPaymentInfoOpen: Function;
}

export const AddCardInfoLink: React.FC<AddCardInfoProps> = ({hasSavedCard, saveNewCard, setAdditionalPaymentInfoOpen}) => {
    return (
        <div style={{fontStyle: 'italic', paddingRight: '10px'}}>
            {translateService.translate('vehicleSearch1.cardSaveAdditionalInfo')}
            <span onClick={() => {setAdditionalPaymentInfoOpen(true)}}
                  style={{textDecoration: "underline", cursor: "pointer"}}>
                                            {translateService.translate('vehicleSearch1.cardSaveAdditionalInfo2')}
                                        </span>
            {hasSavedCard && saveNewCard ?
                <div>
                    <Translate content={'vehicleSearch1.saveCardWillBeReplaced'}/>
                </div> : null}
        </div>
    )
}

